export const LOAD_ANIMAL_WEIGHT_WIDGET_DATA_REQUEST = "[DASHBOARD] LOAD_ANIMAL_WEIGHT_WIDGET_DATA_REQUEST";
